var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"rippleContainer",staticClass:"g_btn_circ_container",style:(( _obj = {}, _obj['border-radius'] = _vm.circle ? '50%' : '', _obj ))},_vm._l((_vm.ripples),function(ripple){return _c('div',{key:ripple.id,staticClass:"g_btn_circ",style:(ripple.style)})}))
var _obj;}
var staticRenderFns = []

export { render, staticRenderFns }